import styled from 'styled-components'

export const Grid = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  position: relative;
  min-height: calc(100vh - 230px);
  height: calc(100% - 92px);
  align-content: flex-start;
`
